import { render } from "./ReportsPage.vue?vue&type=template&id=628261dd"
import script from "./ReportsPage.vue?vue&type=script&lang=js"
export * from "./ReportsPage.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src587305002/src/goku/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__